export const writingCategorySlugs = ["tech", "life", "finance"] as const;

export type WritingCategorySlug = (typeof writingCategorySlugs)[number];

export interface WritingCategory {
  description: string;
  label: string;
  slug: WritingCategorySlug;
}

export const writingCategories = [
  {
    description: "Software, systems, and the process of building products.",
    label: "Tech",
    slug: "tech",
  },
  {
    description: "Homeschooling, family life, decisions, and experiences.",
    label: "Life",
    slug: "life",
  },
  {
    description: "Money systems, business, and independent work.",
    label: "Finance",
    slug: "finance",
  },
] as const satisfies readonly WritingCategory[];

// Resolve a route or frontmatter value to its complete category definition.
export function getWritingCategory(slug: string | undefined) {
  if (!slug) {
    return undefined;
  }

  return writingCategories.find((category) => category.slug === slug);
}
